var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "chatContent-container"
    },
    [
      _c("div", { staticClass: "main-container" }, [
        _c("h3", [
          _vm._v(
            _vm._s(_vm.parmsM.currentMan) +
              "与" +
              _vm._s(_vm.parmsM.withMan || "--") +
              "的聊天摘要"
          )
        ]),
        _c("h4", [
          _vm._v(_vm._s(_vm.parmsM.date) + " " + _vm._s(_vm.parmsM.label))
        ]),
        _c("div", { staticClass: "dangan-row" }, [
          _vm.form.archivesInfos
            ? _c("li", { staticClass: "dangan-title" }, [
                _c("h1", [_vm._v(_vm._s(_vm.form.archivesInfos.ctmName))]),
                _c("h2", [_vm._v(_vm._s(_vm.form.archivesInfos.ctmCode))]),
                _c("span", [_vm._v(_vm._s(_vm.form.archivesInfos.mtyName))])
              ])
            : _vm._e(),
          _vm.form.archivesInfos
            ? _c(
                "li",
                { staticClass: "tab-area" },
                _vm._l(_vm.form.tags, function(item, index) {
                  return _c("div", { key: index, staticClass: "tab-item" }, [
                    item.tagAi
                      ? _c("div", { staticClass: "line" }, [
                          _c("div", {
                            staticClass: "line-l",
                            style: " backgroundColor:" + item.tagColor
                          }),
                          _c("div", {
                            staticClass: "line-r",
                            style: " backgroundColor:" + item.tagColor
                          })
                        ])
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "title-name",
                        style:
                          "color:" +
                          (item.tagAi ? "#FFFFFF" : "#000000") +
                          ";backgroundColor:" +
                          item.tagColor
                      },
                      [_vm._v(" " + _vm._s(item.tagName) + " ")]
                    )
                  ])
                }),
                0
              )
            : _vm._e(),
          !_vm.form.archivesInfos
            ? _c("span", { staticClass: "not-data" }, [_vm._v("未绑定档案")])
            : _vm._e()
        ]),
        _vm.form.responseData
          ? _c("div", {
              staticStyle: { "white-space": "pre-wrap", "margin-top": "10px" },
              domProps: { innerHTML: _vm._s(_vm.form.responseData) }
            })
          : _c(
              "span",
              {
                staticClass: "not-data",
                staticStyle: { "margin-top": "100px" }
              },
              [_vm._v("暂无数据")]
            )
      ]),
      _c("div", { staticClass: "btn-row", on: { click: _vm.viewChat } }, [
        _c("span", [_vm._v("查看聊天记录")])
      ]),
      _vm.chatContentDiaShow
        ? _c("ChatContentDia", {
            ref: "ChatContentDiaRef",
            on: { chatClose: _vm.chatClose }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }